import React from 'react'
import Select from 'react-select'
import { useController } from 'react-hook-form'
import { TAGS } from '../services/Tags'
import { getlanguages } from '../services/Admin'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

const SelectLanguages = ({ control, name, rules, defaultValue, id }) => {
  const { t } = useTranslation()
  const { field } = useController({
    name,
    control,
    defaultValue,
    rules,
  })

  const { data: listLanguagesData } = useQuery(
    [TAGS.list_of_idioms],
    getlanguages
  )

  const options = listLanguagesData?.map(({ id, name, img }) => {
    return { value: id, label: name, flag: img ?? '' }
  })

  const customStyles = {
    option: (provided) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
    }),
    singleValue: (provided) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
    }),
  }

  const formatOptionLabel = ({ label, flag }) => (
    <div id={id} className="d-flex align-items-center gap-2">
      <img
        src={flag}
        alt={label}
        width={12}
        height={12}
        className="rounded-pill"
      />
      <span className="font-small text-on-bg-primary">{label}</span>
    </div>
  )

  return (
    <Select
      {...field}
      options={options}
      styles={customStyles}
      formatOptionLabel={formatOptionLabel}
      placeholder={t('select_a_languages')}
      className="font-small inline-text"
      noOptionsMessage={() => t('language_not_found')}
    />
  )
}

export default SelectLanguages
